import noop from '../../utils/noop';

export default function init(branchKey, callback = noop) {
  const branchUrl = 'https://cdn.branch.io/branch-latest.min.js';

  if (!branchKey) {
    return;
  }

  /* eslint-disable */
  (function(b, r, a, n, c, h, _, s, d, k) {
    if (!b[n] || !b[n]._q) {
      for (; s < _.length; ) {
        c(h, _[s++]);
      }
      d = r.createElement(a);
      d.async = 1;
      d.src = branchUrl;
      k = r.getElementsByTagName(a)[0];
      k.parentNode.insertBefore(d, k);
      b[n] = h;
      window.branch.init(branchKey, function () {
        if (callback) {
          callback();
        }
      });
      // According to branch docs: https://help.branch.io/faq/docs/en/force-a-journey-to-auto-open-the-app-for-users-that-have-it-installed
      // to achieve the desired behavior we need to setup this line
      // desired behavior:
      // Branch link will always open web
      // And web will always force the app opening if installed
      // if not then will remain in web.
      window.branch.setBranchViewData({
        '$uri_redirect_mode': 1
      });
    }
  })(
    window,
    document,
    'script',
    'branch',
    function(b, r) {
      b[r] = function() {
        b._q.push([r, arguments]);
      };
    },
    { _q: [], _v: 1 },
    'addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking'.split(
      ' '
    ),
    0
  );
}
